import * as _4 from 'lodash4';
import { IPlatform, PlatformUtility } from 'utility-ts-platform';
import { HoldCapabilityConfiguration } from '../../../src/configuration';
import { ResolutionType } from '../../builders/resolution_types_builder';
import { IHoldResolution } from '../../holds_interface';

export class HoldResolutionCollectionController {
  private groupName: string;
  private resolutions: ResolutionType[];
  private flags: {
    showResolutionCollection: boolean;
    isMobile: boolean;
  };

  constructor(
    private ngHoldCapabilityConfiguration: HoldCapabilityConfiguration,
    private ngEmailManagementService: any
  ) {
    this.flags = {
      showResolutionCollection: false,
      isMobile: false
    };
  }

  $onInit() {
    this.refresh();
  }

  $onChanges() {
    this.refresh();
  }

  refresh() {
    this.flags = {
      showResolutionCollection: !_4.isEmpty(this.resolutions),
      isMobile: PlatformUtility.isMobile()
    };
  }

  showResolution(resolution: IHoldResolution): boolean {
    return !_4.isEmpty(resolution.metadata.title) || !_4.isEmpty(resolution.metadata.description);
  }

  goToResolution(link: string) {
    if (PlatformUtility.isMobile() && _4.includes(link, 'http')) {
      window.open(link, '_blank', this.ngHoldCapabilityConfiguration.config.appBrowserArguments);
    } else if (PlatformUtility.isMobile() && _4.includes(link, 'mailto:')) {
      this.ngEmailManagementService.sendEmail({ to: _4.split(link, 'mailto:')[1] });
    } else {
      if (PlatformUtility.isAndroid()) {
        window.open(link, '_system');
      } else {
        window.open(link);
      }
    }
  }

  getPlatform(): IPlatform {
    return PlatformUtility.getPlatform();
  }
}

export class HoldResolutionCollectionComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-holds/src/components/hold_resolution_collection/hold_resolution_collection.html';
  public controller: any = HoldResolutionCollectionController;
  public bindings: any = {
    groupName: '<',
    resolutions: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-holds/src/components/hold_resolution_collection/hold_resolution_collection_controller.ts